import request from "./request";
import loader from './loader';

const ajaxnonce = recoverit.ajaxnonce;
const theme_domain = recoverit.theme_domain;

const sorting = document.querySelector('.rit-select-sort');
const categorySelect = document.querySelector('.rit-select-category');
const searchForm = document.getElementById('rit_posts');
const searchInput = document.getElementById('s');

// State object to keep current filters and page
const filterState = {
  s: '',
  term: '',
  sort: '',
  page: 1
};

// Debounce utility
function debounce(func, delay) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), delay);
  };
}

// Unified filter function
function filter() {
    const data = {
            action: `${theme_domain}_posts_ajax_request`,
            ajaxnonce: ajaxnonce,
            method: 'filter',
            s: filterState.s,
            term: filterState.term,
            sort: filterState.sort,
            page: filterState.page
    };

    const container = document.querySelector('.rit-ajax');
    if (container) {
        container.appendChild(loader());
    }

    request(data);
}

// Search input: debounce on typing
if (searchInput) {
  const handleTyping = debounce(() => {
    const searchTerm = searchInput.value.trim();
    if (filterState.s !== searchTerm) {
      filterState.s = searchTerm;
      filterState.page = 1;
      filter();
    }
  }, 600);

  searchInput.addEventListener('input', handleTyping);
}

// Search form: trigger on submit too
if (searchForm) {
  searchForm.addEventListener('submit', event => {
    event.preventDefault();
    const searchTerm = searchInput.value.trim();
    if (filterState.s !== searchTerm) {
      filterState.s = searchTerm;
      filterState.page = 1;
      filter();
    }
  });
}

// Sort select handling
if (sorting) {
  const selected = sorting.querySelector('.rit-select__selected');
  if (selected) {
    const observer = new MutationObserver(() => {
      const newSort = selected.dataset.value || '';
      if (filterState.sort !== newSort) {
        filterState.sort = newSort;
        filterState.page = 1;
        filter();
      }
    });
    observer.observe(selected, { attributes: true, attributeFilter: ['data-value'] });
    filterState.sort = selected.dataset.value || '';
  }
}

// Category select handling
if (categorySelect) {
  const selected = categorySelect.querySelector('.rit-select__selected');
  if (selected) {
    const observer = new MutationObserver(() => {
      const newTerm = selected.dataset.value || '';
      if (filterState.term !== newTerm) {
        filterState.term = newTerm;
        filterState.page = 1;
        filter();
      }
    });
    observer.observe(selected, { attributes: true, attributeFilter: ['data-value'] });
    filterState.term = selected.dataset.value || '';
  }
}

// Pagination handling
document.addEventListener('DOMContentLoaded', () => {
  const paginationContainer = document.querySelector('.rit-pagination');

  if (!paginationContainer) return;

  paginationContainer.addEventListener('click', event => {
    const target = event.target.closest('[data-page]');
    if (target && target.dataset.page) {
      event.preventDefault();
      const page = parseInt(target.dataset.page, 10);
      if (!isNaN(page) && typeof filterState !== 'undefined') {
        filterState.page = page;
        filter();
      }
    }
  });
});
